export function uuid() {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}

export function merge(items: { id?: string, version?: number }[], ritems: { id?: string, version?: number }[]) {
    let res = items.map((x) => {
        let replacement = ritems.find((v) => {
            return v.id === x.id;
        });
        if (replacement) {
            let pos = ritems.indexOf(replacement);
            if (ritems[pos].version < x.version) {
                ritems.splice(pos, 1);
                return x;
            }
            ritems.splice(pos, 1);
            return replacement;
        }
        return x;
    }).filter(x => x);
    res = [...res, ...ritems];
    return res;
}

export const makeCancelable = (promise: any) => {
    let hasCanceled_ = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        promise.then(
            val => hasCanceled_ ? reject({ isCanceled: true }) : resolve(val),
            error => hasCanceled_ ? reject({ isCanceled: true }) : reject(error)
        );
    });

    return {
        promise: wrappedPromise,
        cancel() {
            hasCanceled_ = true;
        },
    };
};